export default [
  {
    path: '/apps/rewards',
    name: 'apps-rewards',
    redirect: { name: 'apps-rewards-dashboard' },
  },
  {
    path: '/apps/rewards/dashboard',
    name: 'apps-rewards-dashboard',
    component: () => import('@/views/apps/rewards/dashboard/RewardsDashboard.vue'),
    meta: {
      title: 'Dashboard',
      resource: 'reward programs',
      action: 'view',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/programs',
    name: 'apps-rewards-programs',
    component: () => import('@/views/apps/rewards/programs/ProgramList.vue'),
    meta: {
      title: 'Programs',
      resource: 'reward programs',
      action: 'view',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/programs/create',
    name: 'apps-rewards-programs-create',
    component: () => import('@/views/apps/rewards/programs/ProgramCreate.vue'),
    meta: {
      title: 'Create Program',
      resource: 'reward programs',
      action: 'create',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/programs/:id',
    name: 'apps-rewards-programs-detail',
    component: () => import('@/views/apps/rewards/programs/ProgramDetail.vue'),
    meta: {
      title: 'Program Detail',
      resource: 'reward programs',
      action: 'view',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/programs/:id/edit',
    name: 'apps-rewards-programs-edit',
    component: () => import('@/views/apps/rewards/programs/ProgramEdit.vue'),
    meta: {
      title: 'Edit Program',
      resource: 'reward programs',
      action: 'edit',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/members',
    name: 'apps-rewards-members',
    component: () => import('@/views/apps/rewards/members/MemberList.vue'),
    meta: {
      title: 'Members',
      resource: 'reward points',
      action: 'view',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/members/:id',
    name: 'apps-rewards-member-detail',
    component: () => import('@/views/apps/rewards/members/MemberDetail.vue'),
    meta: {
      title: 'Member Detail',
      resource: 'reward points',
      action: 'view',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/catalog',
    name: 'apps-rewards-catalog',
    component: () => import('@/views/apps/rewards/catalog/BenefitCatalogPage.vue'),
    meta: {
      title: 'Katalog Hadiah',
      resource: 'reward points',
      action: 'view',
      feature: 'loyalty',
    },
  },
  {
    path: '/apps/rewards/catalog/:norm',
    name: 'apps-rewards-catalog-patient',
    component: () => import('@/views/apps/rewards/catalog/BenefitCatalogPage.vue'),
    meta: {
      title: 'Katalog Hadiah',
      resource: 'reward points',
      action: 'view',
      feature: 'loyalty',
    },
  },
]
